import {
  isFieldPartIdentifier,
  isFieldGroupPartIdentifier,
  isSectionPartIdentifier,
  isSelectOptionPartIdentifier,
  isSubsectionPartIdentifier,
  PartIdentifier,
} from '@zinnia/form-engine-sdk';

export function isPartIdentifierAChild(
  potentialChildPartIdentifier: PartIdentifier,
  potentialParentPartIdentifier: PartIdentifier,
): boolean {
  if (
    isSectionPartIdentifier(potentialParentPartIdentifier) &&
    (isSubsectionPartIdentifier(potentialChildPartIdentifier) ||
      isFieldGroupPartIdentifier(potentialChildPartIdentifier) ||
      isFieldPartIdentifier(potentialChildPartIdentifier) ||
      isSelectOptionPartIdentifier(potentialChildPartIdentifier))
  ) {
    return potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName;
  }
  if (
    isSubsectionPartIdentifier(potentialParentPartIdentifier) &&
    (isFieldGroupPartIdentifier(potentialChildPartIdentifier) ||
      isFieldPartIdentifier(potentialChildPartIdentifier) ||
      isSelectOptionPartIdentifier(potentialChildPartIdentifier))
  ) {
    return (
      potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName &&
      potentialParentPartIdentifier.subsectionPartName === potentialChildPartIdentifier.subsectionPartName
    );
  }
  if (
    isFieldGroupPartIdentifier(potentialParentPartIdentifier) &&
    (isFieldPartIdentifier(potentialChildPartIdentifier) || isSelectOptionPartIdentifier(potentialChildPartIdentifier))
  ) {
    return (
      potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName &&
      potentialParentPartIdentifier.subsectionPartName === potentialChildPartIdentifier.subsectionPartName &&
      potentialParentPartIdentifier.fieldGroupPartName === potentialChildPartIdentifier.fieldGroupPartName
    );
  }
  if (
    isFieldPartIdentifier(potentialParentPartIdentifier) &&
    isSelectOptionPartIdentifier(potentialChildPartIdentifier)
  ) {
    return (
      potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName &&
      potentialParentPartIdentifier.subsectionPartName === potentialChildPartIdentifier.subsectionPartName &&
      potentialParentPartIdentifier.fieldGroupPartName === potentialChildPartIdentifier.fieldGroupPartName &&
      potentialParentPartIdentifier.fieldPartName === potentialChildPartIdentifier.fieldPartName
    );
  }
  return false;
}
